import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';

type RenderSharedClaimNumberProps = ICasRenderCellProps & {
  onClick: VoidFunction;
};

// A Claim# on more than one claim is a link to the dialog listing them all; anything else is the
// plain value.  No MULTI badge here - unlike the Claim Details dialog, the value itself is the link.
export default function RenderSharedClaimNumber({ row, onClick }: RenderSharedClaimNumberProps) {
  if (!row?.hasSharedClaimNumber) return row?.claimNumber;

  return <CasLink onClick={onClick}>{row.claimNumber}</CasLink>;
}
